import { type SkeletonProps } from '~/components/component-library/Skeleton/types'
import { cn } from '~/utils/tailwind-utils'

export { type SkeletonProps } from '~/components/component-library/Skeleton/types'

// Full class names, so Tailwind can find them in the source.
const sizes = {
  xs: { height: 'h-3', diameter: 'w-3 h-3' },
  sm: { height: 'h-4', diameter: 'w-4 h-4' },
  md: { height: 'h-8', diameter: 'w-8 h-8' },
  lg: { height: 'h-16', diameter: 'w-16 h-16' },
}

export const Skeleton = ({
  length,
  height,
  size = 'md',
  circle = false,
  className = '',
}: SkeletonProps) => {
  return circle ? (
    <div
      className={cn(
        'inline-block rounded-full bg-surface-strong',
        sizes[size].diameter,
        className,
      )}
    />
  ) : (
    <div
      className={cn(
        sizes[size].height,
        'w-full animate-pulse rounded-lg bg-surface-strong',
        className,
      )}
      style={{
        ...(length && { width: `${length}rem` }),
        ...(height && { height: `${height}rem` }),
      }}
    />
  )
}
